// Shared by the device model pickers: new device form, unified edit modal, missing models, price sheet items.
// Identifier matches too, so "MacBookAir10,1" off an intake sheet finds the model.
//
// Names match word-by-word so "ipad 10" finds "iPad (WiFi, 10th generation)" — Apple's naming
// isn't consistent enough for a straight substring. Identifiers stay a whole-query substring on
// purpose: they run a generation ahead of the marketing names (iPhone13,x IS the iPhone 12), so
// letting "13" match the identifier while "iphone" matches the name makes "iphone 13" match every
// iPhone 12. Same reason not to strip the punctuation.
window.matchDeviceModels = (models, query) => {
  const search = query.toLowerCase().trim();
  const words = search.split(/\s+/);

  return models.filter(model => {
    const name = model.name.toLowerCase();

    return words.every(word => name.includes(word)) ||
      (model.identifier || '').toLowerCase().includes(search);
  });
};
